module.exports = __webpack_public_path__ + "img/comochegar02.8c2214cc.jpg";